(function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments)
    }, i[r].l = 1 * new Date(); a = s.createElement(o),
    m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
})(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

function setGAKey(ga__key) {
    ga('create', ga__key, 'auto');
}

function invokeTracker(o){

if(o[0].type == 'event') {
    ga('send', {
    'hitType': 'event',             // required.
    'eventCategory': o[0].category,    // required.
    'eventAction': o[0].action,         // required.y

    'eventLabel': o[0].label
    });
}else{
    ga('send', 'pageview', {
    'page': o[0].page,
    'title': o[0].title
    });
}
}

function appTimings(params) {
ga('send', params);
}